import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
import user from "./modules/user";
import conversations from "./modules/conversations";
import agency from "./modules/agency";
import provider from "./modules/provider";
import video from "./modules/video";
import connection from "./modules/connection";
import transcription from "./modules/transcription";
import attachment from "./modules/attachment";
import persist from "./modules/persist";
import pinnacle from "./modules/pinnacle";
import campaigns from "./modules/campaigns";
import sentiment from "./modules/sentiment";
import keywords from "./modules/keywords";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    conversations,
    agency,
    provider,
    video,
    connection,
    transcription,
    attachment,
    persist,
    pinnacle,
    campaigns,
    sentiment,
    keywords,
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      key: "convey911",
      paths: [
        "user.isDarkMode",
        "user.userTheme",
        "user.volume",
        "user.userDashboardView",
        "persist.userVideoRequest",
        "persist.lastQuickReply",
        "sentiment",
        "agency.lastSelectedModule",
      ],
    }),
    createPersistedState({
      storage: window.sessionStorage,
      key: "convey911",
      paths: [
        "connection",
        "persist.tableSettings",
        "user.userSidebarOpened",
        "user.userCreateNewPoppver",
        "agency.selectedAgencyModule",
        "agency.agencyModules",
        "video",
      ],
    }),
  ],
});
